/** Kipify remote MCP — customer-facing constants (English product surface). */
export const KIPIFY_MCP_SERVER_URL = 'https://api.kipify.io/mcp';

/** Official client docs (UI steps change often — link, don’t screenshot). */
export const CLAUDE_MCP_SETUP_DOCS_URL =
  'https://support.claude.com/en/articles/11175166-get-started-with-custom-connectors-using-remote-mcp';

/** Official Kipify plugin listing in ChatGPT Plugins directory. */
export const CHATGPT_KIPIFY_PLUGIN_URL =
  'https://chatgpt.com/plugins/plugin_asdk_app_6acd50614df481919627628425b1b357';
